import { State } from 'xstate';
import { reactivateSubscription } from './reactivateSubscription';

type ReactivateSubscriptionMachine = typeof reactivateSubscription;
type ReactivateSubscriptionState = State<
  ReactivateSubscriptionMachine['context']
>;

export const getReactivateSubscriptionStatus = (
  machineState: ReactivateSubscriptionState
) => ({
  idle: machineState.matches('idle'),
  reactivateSubscriptionLoading: machineState.matches('reactivateSubscription'),
  reactivateSubscriptionSuccess: machineState.matches('success'),
  reactivateSubscriptionError: machineState.matches('error'),
});

export const getErrorCode = (machineState: ReactivateSubscriptionMachine) => {
  return machineState.context.error;
};

export const reactivateSubscriptionSelectors = {
  getReactivateSubscriptionStatus,
  getErrorCode,
};
